import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { TopArtificial } from "../assets/topArtificial";
import { TopMachine } from "../assets/topMachine";
import { TopProfit } from "../assets/topProfit";
import { ExternalLink } from "../assets/externalLink";
import { FooterLogo } from "../assets/footerLogo";
import { Button } from "../ui/Button";
import { Facebook } from "../assets/facebook";
import { LinkedIn } from "../assets/linkedin";
import { X } from "../assets/x";
import { Youtube } from "../assets/youtube";
import { Instagram } from "../assets/instagram";
import { Drimbbble } from "../assets/dribbble";
import { TikTok } from "../assets/tiktok";
import { Xing } from "../assets/xing";
import { FaRegCircleCheck } from "react-icons/fa6";
import { Link } from "react-router-dom";
export const Footer = () => {
  const [email, setEmail] = useState("");
  const { t, i18n } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const [errors, setErrors] = useState<{ email?: string; checkbox?: string }>(
    {}
  );
  const [isSubscribed, setIsSubscribed] = useState(false);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async () => {
    const newErrors: { email?: string; checkbox?: string } = {};

    if (!email || !validateEmail(email)) {
      newErrors.email = t("subscribeValidation.emailValidaton");
    }

    if (!isChecked) {
      newErrors.checkbox = t("subscribeValidation.termsValidation");
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await fetch(
          "https://site-backend.assist.ro/api/webform_submission/footer_newsletter",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, tc: isChecked }),
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to submit: ${response.statusText}`);
        }

        setIsSubscribed(true);
      } catch (error) {
        setErrors({ email: "Submission failed. Please try again later." });
      }
    }
  };

  const FooterSocialsMedia = [
    {
      icon: <Facebook />,
      link: "https://www.facebook.com/assist.software.development",
    },
    {
      icon: <LinkedIn />,
      link: "https://www.linkedin.com/company/assist-software-srl",
    },
    { icon: <X />, link: "https://twitter.com/assistsoftware" },
    { icon: <Youtube />, link: "https://www.youtube.com/@Assist-softwareNet" },
    { icon: <Instagram />, link: "https://www.instagram.com/assist.software" },
    {
      icon: <Drimbbble />,
      link: "https://dribbble.com/assist-software-design",
    },
    { icon: <TikTok />, link: "https://www.tiktok.com/@assist.software" },
    { icon: <Xing />, link: "https://www.xing.com/pages/assistsoftwaresrl" },
  ];
  const isAddress = (text: string) =>
    text.includes("Suceava") || text.includes("Augsburg");

  const isPhoneNumber = (text: string) =>
    text.startsWith("+40") || /^\d+$/.test(text.replace(/[\s-]/g, ""));

  const isEmail = (text: string) => text.includes("@") && text.includes(".");

  const pages = t("footerPagesSection.pages", { returnObjects: true }) as {
    name: string;
    link: string;
  }[];

  const info = t("footerInfo", {
    returnObjects: true,
  }) as string[];

  return (
    <div className="border-t border-[1px] border-neutral-500 bg-neutral-600 py-6">
      <div className="px-[10px] md:px-6-res py-2-res md:grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-[1300px] justify-self-center lg:gap-[100px]">
        <div className="md:col-span-2 flex flex-col flox-wrap md:flex-row gap-[26px] items-center md:items-start md:justify-center">
          <div className="flex flex-col gap-5">
            <div className="flex gap-1">
              <TopArtificial />
              <TopMachine />
            </div>
            <div>
              <TopProfit />
            </div>
          </div>
          <div className="flex flex-col gap-4 text-primary-700 text-[14px] font-500 min-w-fit">
            <p>{String(t("footerPagesSection.title"))}</p>
            {pages.map((eachpage, index) => {
              const isInternal = eachpage.link.startsWith("/");

              return isInternal ? (
                <Link
                  key={index}
                  to={
                    i18n.language === "de" && !eachpage.link.endsWith("/de")
                      ? `${eachpage.link}/de`
                      : eachpage.link
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex gap-1 hover:text-primary-200 underline"
                >
                  {eachpage.name} <ExternalLink />
                </Link>
              ) : (
                <a
                  key={index}
                  href={eachpage.link}
                  className="flex gap-1 hover:text-primary-200 underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {eachpage.name} <ExternalLink />
                </a>
              );
            })}
          </div>
          <div className="flex flex-col gap-4 text-primary-700 text-[14px] font-500 min-w-[200px]">
            {info.map((eachinfo, index) => {
              if (isAddress(eachinfo)) {
                const mapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(eachinfo)}`;
                return (
                  <a
                    key={index}
                    href={mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline hover:text-primary-200"
                  >
                    {eachinfo}
                  </a>
                );
              }

              if (isPhoneNumber(eachinfo)) {
                return (
                  <a
                    key={index}
                    href={`tel:${eachinfo.replace(/\s/g, "")}`}
                    className="hover:underline hover:text-primary-200"
                  >
                    {eachinfo}
                  </a>
                );
              }

              if (isEmail(eachinfo)) {
                return (
                  <a
                    key={index}
                    href={`mailto:${eachinfo}`}
                    className="hover:underline hover:text-primary-200"
                  >
                    {eachinfo}
                  </a>
                );
              }

              return <p key={index}>{eachinfo}</p>;
            })}
          </div>
        </div>
        <div className="flex flex-col gap-[13px] w-fit min-w-[340px] mt-[30px] md:mt-0 md:justify-self-center md:w-[70%]">
          <div className="flex flex-col gap-[13px] items-center">
            <FooterLogo />
            <p className="text-[14px] font-500 text-primary-700">
              {String(t("footerSubscribe.subtitle"))}
            </p>
          </div>
          {isSubscribed ? (
            <div className="text-primary-700 text-[14px] font-500 flex flex-col gap-2">
              <div className="flex gap-2">
                <FaRegCircleCheck size={20} />
                <p>{String(t("subscribed.thankYou"))}</p>
              </div>
              <p>{String(t("subscribed.thankYouSubtitle"))}</p>
            </div>
          ) : (
            <>
              <div className="flex gap-[15px] place-items-center">
                <input
                  className={`border rounded-[7px] border-primary-200 px-[8px] w-[204px] h-[38px] focus:border-primary-100 focus:ring-1 focus:ring-primary-100 focus:outline-none ${errors.email ? "border-red-100 focus:border-red-100 focus:ring-red-100" : ""}`}
                  placeholder={String(t("emailPlaceholder"))}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button label={t("buttons.subscribe")} onClick={handleSubmit} />
              </div>
              {errors.email && (
                <p className="text-red-100 text-[12px]">{errors.email}</p>
              )}
              <div className="flex items-center gap-1">
                <input
                  type="checkbox"
                  className={`border rounded-[7px] border-primary-200 w-[20px] h-[20px] mr-[8px] focus:border-primary-100 focus:ring-1 focus:ring-primary-100 focus:outline-none checked:text-primary-100 ${errors.checkbox ? "border-red-100 focus:border-red-100 focus:ring-red-100" : ""}`}
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
                <p className="text-primary-700 text-[14px] font-400">
                  {String(t("subscribe.read"))}
                  <a
                    className="font-500 italic underline  hover:text-primary-200"
                    href={
                      i18n.language === "de" &&
                      !"/terms-of-service".endsWith("/de")
                        ? "/terms-of-service/de"
                        : "/terms-of-service"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {String(t("subscribe.terms"))}
                  </a>{" "}
                  <span className="font-500 italic">
                    {String(t("subscribe.and"))}
                  </span>{" "}
                  <a
                    className="font-500 italic underline  hover:text-primary-200"
                    href={
                      i18n.language === "de" &&
                      !"/privacy-policy".endsWith("/de")
                        ? "/privacy-policy/de"
                        : "/privacy-policy"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {String(t("subscribe.policy"))}
                  </a>
                  {String(t("subscribe.dot"))}
                </p>
              </div>
            </>
          )}
          <div className="flex flex-col gap-[13px]">
            <p className="text-[14px] font-500 text-primary-700">
              {String(t("footerSubscribe.follow"))}
            </p>
            <div className="flex flex-wrap gap-2 max-w-[200px]">
              {FooterSocialsMedia.map((eachSocial, index) => (
                <a
                  href={eachSocial.link}
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {eachSocial.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
